import { Injectable, inject } from '@angular/core';
import { ApiService } from '../services/api.service';
import { NotifiedPersonContact, VisitorInfo } from '../visit/visit.types';

/**
 * Host / reception notifications (SPECS §4.1, §5.1, §5.2).
 *
 * Fire-and-forget by design: notification failures must never block the visitor
 * flow — the borne always navigates to the waiting screen regardless. Errors
 * surface in the console so ops/QA can see them, but the backend orchestrates
 * the actual delivery (SMS gateway / Brevo) and template rendering.
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly api = inject(ApiService);

  notifyHost(visitor: VisitorInfo, host: NotifiedPersonContact): void {
    if (!this.hasName(visitor) || !this.hasName(host)) return;

    this.api
      .post('/visit/notify-host', {
        visitor: this.cleanContact(visitor),
        host: this.cleanContact(host),
      })
      .subscribe({
        error: (err) => console.error('notifyHost failed', err),
      });
  }

  notifyReception(visitor: VisitorInfo): void {
    if (!this.hasName(visitor)) return;

    this.api
      .post('/visit/notify-reception', {
        visitor: this.cleanContact(visitor),
      })
      .subscribe({
        error: (err) => console.error('notifyReception failed', err),
      });
  }

  private hasName(c: { firstName?: string; lastName?: string }): boolean {
    return !!(c.firstName?.trim() || c.lastName?.trim());
  }

  private cleanContact<T extends { firstName?: string; lastName?: string; email?: string; phone?: string }>(
    c: T,
  ): T {
    return {
      ...c,
      firstName: c.firstName?.trim(),
      lastName: c.lastName?.trim(),
      email: c.email?.trim() || undefined,
      phone: c.phone?.trim() || undefined,
    };
  }
}
